import React, { useEffect, useState } from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import BackArrowIcon from "../../../components/Icons/BackArrowIcon";
import { handleStatus } from "../../../utility/CommonFunctions";
import DocumentIcon from "../../../components/Icons/DocumentIcon";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { toast } from "react-toastify";
import ViewDocumentModal from "../ViewDocumentModal";
import MainHeading from "../../../components/comman/MainHeading";
import moment from "moment";

export default function CompanyDetail() {
  let { id } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const userDetails = useSelector((state) => state.root.userDetails);
  const navigate = useNavigate();
  const [companyDetail, setCompanyDetail] = useState({});
  const [modal, setModal] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const toggleModal = () => {
    setModal(!modal);
  };

  const GetCompayDetail = () => {
    let options = {
      method: "GET",
    };
    let API = apiUrl?.get_company + `?companyId=${id}`;
    setIsLoading(true);
    callApi(API, options).then((response) => {
      setIsLoading(false);
      if (response?.status === true) {
        setCompanyDetail(response?.data?.company[0]);
      } else {
        toast.error(response?.message);
      }
    });
  };
  const handleDocumentClick = (item) => {
    const docUrl = {
      url: item?.url,
    };
    setSelectedDocument(docUrl);
    setModal(true);
  };

  useEffect(() => {
    GetCompayDetail();
  }, []);

  return (
    <>
      <div className="content container-fluid">
        <MainHeading title="Company Detail" showBackButton={true} />
        <div className="card manage-user-list">
          <div className="card-body">
            <ul className={isLoading ? "row list-unstyled mt-4 loading-skeleton" : "row list-unstyled mt-4"}>
              {companyDetail?.documents?.find(
                (item) => item?.name === "Company_Logo"
              ) && (
                  <li className="col-12 col-md-6 col-lg-4">
                    <p>
                      <span className="text-muted fs-5 d-block">
                        Company Logo :-
                      </span>
                      <img
                        className=""
                        width={"50px"}
                        src={
                          companyDetail?.documents?.find(
                            (item) => item?.name === "Company_Logo"
                          )?.url
                        }
                      />
                    </p>
                  </li>
                )}
              <li className="col-12 col-md-6 col-lg-4">
                <p>
                  <span className="text-muted fs-5 d-block">
                    Company Name :-
                  </span>
                  {companyDetail?.name || "--"}
                </p>
              </li>
              <li className="col-12 col-md-6 col-lg-4">
                <p>
                  <span className="text-muted fs-5 d-block">
                    Short Name :-
                  </span>
                  {companyDetail?.shortName || "--"}
                </p>
              </li>
              <li className="col-12 col-md-6 col-lg-4">
                <p>
                  <span className="text-muted fs-5 d-block">
                    Company Email :-
                  </span>
                  {companyDetail?.email || "--"}
                </p>
              </li>
              <li className="col-12 col-md-6 col-lg-4">
                <p>
                  <span className="text-muted fs-5 d-block">
                    Secondary Email :-
                  </span>
                  {companyDetail?.secondaryEmail || "--"}
                </p>
              </li>
              <li className="col-12 col-md-6 col-lg-4">
                <p>
                  <span className="text-muted fs-5 d-block">
                    Company Contact Number :-
                  </span>
                  {companyDetail?.phone || "--"}
                </p>
              </li>
              <li className="col-12 col-md-6 col-lg-4">
                <p>
                  <span className="text-muted fs-5 d-block">
                    Secondary Contact Number :-
                  </span>
                  {companyDetail?.secondaryPhone || "--"}
                </p>
              </li>
              <li className="col-12 col-md-6 col-lg-4">
                <p>
                  <span className="text-muted fs-5 d-block">GST Number :-</span>
                  {companyDetail?.gst || "--"}
                </p>
              </li>
              <li className="col-12 col-md-6 col-lg-4">
                <p>
                  <span className="text-muted fs-5 d-block">Address :-</span>
                  {companyDetail?.address || "--"}
                </p>
              </li>
            </ul>
          </div>
        </div>

        <div className="row">
          <div className="card manage-user-list">
            <div className="card-body">
              <div className="d-flex align-items-center justify-content-between border-bottom mb-3">
                <h4 className="d-flex align-items-center mb-4">Bank Details</h4>
              </div>
              <ul className="row list-unstyled gap-3">
                <li className="col-12 col-md-6 col-lg-4">
                  <p>
                    <span className="text-muted fs-5 d-block">Account Holder :-</span>
                    {companyDetail?.accountHolder || "--"}
                  </p>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <p>
                    <span className="text-muted fs-5 d-block">Account Number :-</span>
                    {companyDetail?.accountNumber || "--"}
                  </p>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <p>
                    <span className="text-muted fs-5 d-block">IFSC Code :-</span>
                    {companyDetail?.IFSC_code || "--"}
                  </p>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <p>
                    <span className="text-muted fs-5 d-block">Branch Name :-</span>
                    {companyDetail?.branchName || "--"}
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="card manage-user-list">
            <div className="card-body">
              <div className="d-flex align-items-center justify-content-between border-bottom mb-3">
                <h4 className="d-flex align-items-center mb-4">Documents</h4>
              </div>
              <ul className="row list-unstyled gap-3">
                {companyDetail?.documents?.length > 0 ? (
                  companyDetail?.documents?.map((doc, index) => {
                    const updatedDate = moment(doc?.updatedAt).format("DD MMM YYYY | h:mm a");
                    return (
                      <li key={index} className="col-12">
                        <div
                          className="text-muted fs-5 d-flex align-items-center justify-content-between text-decoration-none w-100"
                          onClick={() => handleDocumentClick(doc)}
                          role="button"
                        >
                          <span className="d-flex align-items-center gap-2">
                            <DocumentIcon />
                            {doc?.name || "Document"}
                          </span>
                          <span className="fs-6">
                            {updatedDate || ""}
                          </span>
                        </div>
                      </li>
                    );
                  })
                ) : (
                  <div>No Document Found</div>
                )}
              </ul>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="card manage-user-list">
            <div className="card-body">
              <div className="d-flex align-items-center justify-content-between border-bottom mb-3">
                <h4 className="d-flex align-items-center mb-4">
                  Terms & Conditions
                </h4>
              </div>
              <ul className="row list-unstyled gap-3">
                <div>
                  <CKEditor
                    editor={ClassicEditor}
                    data={companyDetail?.tANDc}
                    disabled
                    config={{
                      toolbar: [
                        "heading",
                        "|",
                        "bold",
                        "italic",
                        "underline",
                        "strikethrough",
                        "|",
                        "fontColor",
                        "fontBackgroundColor",
                        "fontFamily",
                        "fontSize",
                        "alignment",
                        "|",
                        "link",
                        "bulletedList",
                        "numberedList",
                        "blockQuote",
                        "undo",
                        "redo",
                      ],
                      image: {
                        toolbar: [
                          "imageStyle:alignLeft",
                          "imageStyle:alignCenter",
                          "imageStyle:alignRight",
                          "|",
                          "imageTextAlternative",
                        ],
                      },
                      height: "500px", // custom height for CKEditor
                    }}
                  />
                </div>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <ViewDocumentModal
        modal={modal}
        toggle={toggleModal}
        selectedDocument={selectedDocument}
      />
    </>
  );
}
